import axios from './axiosConfig';

const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.demo1.raborisk.ai" 
    : "http://localhost:3000";

// Check survey status
export const checkSurveyStatus = () => async (dispatch, getState) => {
    try {
        const response = await axios.get(API_URL + '/api/survey/status');
        return response.data;
    } catch (error) {
        console.error('Error checking survey status:', error);
        throw error;
    }
};

// Submit survey
export const submitSurvey = (surveyData) => async (dispatch, getState) => {
    try {
        const response = await axios.post(API_URL + '/api/survey/submit', surveyData);
        //console.log("subnmit rpesonxe ", response)
        return response.data;
    } catch (error) {
        console.error('Error submitting survey:', error);
        throw error;
    }
};

export const getFindingsBySurvey = (survey_id) => {
    return (dispatch) => {
        return axios
            .post(`${API_URL}/api/risk/get_findings_by_survey`, { survey_id })
            .then(({ data }) => {
                if (data?.success && Array.isArray(data.findings)) {
                    dispatch({
                        type: "FINDINGS_BY_SURVEY_SET",
                        payload: data.findings,
                    });
                    return data.findings;
                }
                throw new Error("API response missing findings");
            })
            .catch((err) => {
                console.error("Error in getFindingsBySurvey:", err);
                throw err;
            });
    };
};

export const getActionsBySurvey = (survey_id) => {
    return (dispatch) => {
        return axios
            .post(`${API_URL}/api/risk/get_actions_by_survey`, { survey_id })
            .then(({ data }) => {
                const actions = Array.isArray(data) ? data : (data?.actions ?? []);
                dispatch({ type: "SURVEY_ACTIONS_SET", payload: actions });
                console.log("actions ", actions)
                return actions;
            })
            .catch((err) => {
                console.error("Error in getActionsBySurvey:", err);
                throw err;
            });
    };
};

export const getAllSurveyFindings = () => (dispatch) =>
    axios
        .get(`${API_URL}/api/risk/get_all_survey_findings`)
        .then(({ data }) => {
            console.log('[getAllSurveyFindings] raw response:', data);
            const result = Array.isArray(data) ? data : (data?.findings ?? []);
            console.log('[getAllSurveyFindings] returning:', result);
            return result;
        })
        .catch((err) => {
            console.error('[getAllSurveyFindings] error:', err);
            return [];
        });

export const getAllSurveyActions = () => (dispatch) =>
    axios
        .get(`${API_URL}/api/risk/get_all_survey_actions`)
        .then(({ data }) => {
            console.log('[getAllSurveyActions] raw response:', data);
            const result = Array.isArray(data) ? data : (data?.actions ?? []);
            console.log('[getAllSurveyActions] returning:', result);
            return result;
        })
        .catch((err) => {
            console.error('[getAllSurveyActions] error:', err);
            return [];
        });

export const saveSurveyDraft = (surveyData) => async (dispatch, getState) => {
    //console.log("surveyData ", surveyData)
    try {
        const response = await axios.post(
            API_URL + '/api/survey/save_draft',
            surveyData
        );
        return response.data;
    } catch (error) {
        console.error('Error saving survey draft:', error);
        throw error;
    }
};

export const createEmptySurveyQuestion = (payload) => async (dispatch) => {
    try {
        const response = await axios.post(
            API_URL + '/api/survey/create-empty',
            payload
        );

        return response.data;
    } catch (error) {
        console.error('Error creating empty survey question:', error);
        throw error;
    }
};

export const deploySurveyTemplate = (templateData) => async (dispatch, getState) => {
    try {
        //console.log(templateData)
        const response = await axios.post(
            API_URL + '/api/survey/deploy',
            templateData
        );
        return response.data;
    } catch (error) {
        console.error('Error deploying survey template:', error);
        throw error;
    }
};

// Get survey by ID
export const getSurveyById = (id) => async (dispatch, getState) => {
    try {
        const response = await axios.get(API_URL + `/api/survey/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error getting survey:', error);
        throw error;
    }
};

// Get all surveys (admin)
export const getAllSurveys = () => {
    //console.log("Getting al surveys")
    return (dispatch) => {
        axios.get(API_URL + "/api/survey").then(({ data }) => {
            dispatch({ type: "GET_SURVEYS", payload: data });
        });
    }
};

export const getAllSurveysTemplate = () => {
    //console.log("Getting all survey templates");
    return (dispatch) => {
        axios.get(API_URL + "/api/survey/templates")
            .then(({ data }) => {
                dispatch({ type: "GET_SURVEYS_TEMPLATE", payload: data });
            });
    };
};

export const getSurveyQuestionById = (questionId) => {
    //console.log("Getting survey question by id:", questionId);

    return (dispatch) => {
        axios
            .get(API_URL + `/api/survey/question/${questionId}`)
            .then(({ data }) => {
                //console.log("Question ", data)
                dispatch({
                    type: "GET_SURVEY_QUESTION_BY_ID",
                    payload: data
                });
            })
            .catch((err) => {
                console.error("Failed to get survey question by id:", err);
            });
    };
};


export const editAudit = (audit_id, payload) => {
    //console.log("edt payload ", payload)
  return (dispatch) => {
    return axios
      .post(API_URL + "/api/survey/audits/" + audit_id, payload)
      .then(({ data }) => {
        dispatch({ type: "EDIT_AUDIT_SUCCESS", payload: { audit_id, data } });
        return data;
      })
      .catch((err) => {
        console.error("Failed to edit audit", err);
        dispatch({ type: "EDIT_AUDIT_ERROR", error: err });
        throw err;
      });
  };
};

export const editSurveyQuestion = (question_id, payload) => {
  console.log("edit question payload ", payload);

  return (dispatch) => {
    return axios
      .post(API_URL + "/api/survey/question/" + question_id, payload)
      .then(({ data }) => {
        dispatch({
          type: "EDIT_SURVEY_QUESTION_SUCCESS",
          payload: { question_id, data }
        });
        return data;
      })
      .catch((err) => {
        console.error("Failed to edit survey question", err);
        dispatch({
          type: "EDIT_SURVEY_QUESTION_ERROR",
          error: err
        });
        throw err;
      });
  };
};


export const assignOwnerToSurveyClause = (payload) => async (dispatch, getState) => {
    try {
        const { token } = getState().auth;
        const response = await axios.post(API_URL + '/api/survey/assign_owner', payload, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error assigning owner to survey clause:', error);
        throw error;
    }
};

export const getAuditDepartments = () => {
    return (dispatch) => {
        axios
            .get(API_URL + "/api/survey/audit/departments")
            .then(({ data }) => {
                dispatch({
                    type: "GET_AUDIT_DEPARTMENTS",
                    payload: data,
                });
            })
            .catch((err) => {
                console.error("getAuditDepartments error", err);
            });
    };
};



// Get all audits (admin)
export const getAllAudits = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/survey/audits").then(({ data }) => {
            dispatch({ type: "GET_AUDITS", payload: data });
        });
    }
};

export const getAllAuditTemplates = () => {
    return (dispatch) => {
        axios
            .get(API_URL + "/api/survey/audit_templates")
            .then(({ data }) => {
                //console.log(data)
                dispatch({
                    type: "GET_AUDIT_TEMPLATES",
                    payload: data
                });
            });
    };
};


// Get audit by id (returns audit object)
export const getAuditById = (audit_id) => {
    return (dispatch) => {
        return axios
            .get(API_URL + "/api/survey/audits/" + audit_id)
            .then(({ data }) => {
                // optional: dispatch if you want to store in redux
                // dispatch({ type: "GET_AUDIT_BY_ID_SUCCESS", payload: data });
                return data; // ✅ caller gets the audit
            })
            .catch((err) => {
                console.error("Failed to get audit by id", err);
                throw err; // ✅ caller can catch
            });
    };
};


// Create audit
export const createAudit = (payload) => {
    //console.log(payload)
    return (dispatch) => {
        return axios
            .post(API_URL + "/api/survey/create", payload)
            .then(({ data }) => {
                dispatch({ type: "CREATE_AUDIT_SUCCESS", payload: data });
                return data; // ✅ important
            })
            .catch((err) => {
                console.error("Failed to create audit", err);
                dispatch({ type: "CREATE_AUDIT_ERROR", error: err });
                throw err; // ✅ allow await to catch
            });
    };
};



export const deleteAudit = (audit_id) => {
  return (dispatch) => {
    axios
      .delete(API_URL + "/api/survey/audits/" + audit_id)
      .then(() => {
        dispatch({ type: "DELETE_AUDIT_SUCCESS", audit_id });
        dispatch(getAllAudits()); // refresh
      })
      .catch((err) => {
        console.error("Failed to delete audit", err);
        dispatch({ type: "DELETE_AUDIT_ERROR", error: err });
      });
  };
};

export const addSurveyQuestionComment = (comment, question_id) => {
  return (dispatch) => {
    axios
      .post(API_URL + "/api/survey/add_survey_question", {
        comment: comment,
        question_id: question_id,
      })
      .then(({ data }) => {
        dispatch({
          type: "SURVEY_QUESTION_DETAILS",
          question_details: data.data,
          comments: data.comments,
        });
      });
  };
};


// Upload survey file
export const uploadSurveyFile = (file, questionId, survey_id, metadata = {}) => async (dispatch, getState) => {
    try {
        const { token } = getState().auth;
        const formData = new FormData();
        formData.append('file', file);
        if (metadata.evidence_title) formData.append('evidence_title', metadata.evidence_title);
        if (metadata.vendor)         formData.append('vendor', metadata.vendor);
        if (metadata.type)           formData.append('type', metadata.type);
        if (metadata.category)       formData.append('category', metadata.category);
        if (metadata.expiry_date)    formData.append('expiry_date', metadata.expiry_date);
        if (metadata.status)         formData.append('status', metadata.status);
        if (metadata.tags)           formData.append('tags', JSON.stringify(metadata.tags));
        const response = await axios.post(API_URL + '/api/files/add_survey_file', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
                'question_id': questionId,
                'survey_id': survey_id,
                'current_folder': '/surveys'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading survey file:', error);
        throw error;
    }
};

// Get survey files
export const getSurveyFiles = (surveyId, questionId) => async (dispatch, getState) => {
    try {
        //console.log("surveyId " , surveyId)
        let url = API_URL + '/api/files/get_survey_files?';
        if (surveyId) url += `survey_id=${surveyId}&`;
        if (questionId) url += `question_id=${questionId}`;
        
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('Error getting survey files:', error);
        throw error;
    }
};

// Delete survey file
export const getEvidence = ({ survey_id, question_id, evidence_id } = {}) => async (dispatch, getState) => {
    try {
        const params = new URLSearchParams();
        if (evidence_id) params.append('evidence_id', evidence_id);
        if (survey_id)   params.append('survey_id', survey_id);
        if (question_id) params.append('question_id', question_id);
        const response = await axios.get(API_URL + '/api/files/get_evidence?' + params.toString());
        return response.data;
    } catch (error) {
        console.error('Error getting evidence:', error);
        throw error;
    }
};

export const updateSurveyEvidence = (evidenceId, metadata) => async (dispatch, getState) => {
    try {
        const { token } = getState().auth;
        const response = await axios.post(API_URL + '/api/files/update_evidence', { evidence_id: evidenceId, ...metadata }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating evidence:', error);
        throw error;
    }
};

export const deleteEvidence = (evidenceId) => async (dispatch, getState) => {
    try {
        const { token } = getState().auth;
        const response = await axios.post(API_URL + '/api/files/delete_evidence', { evidence_id: evidenceId }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting evidence:', error);
        throw error;
    }
};

export const deleteSurveyFile = (fileId) => async (dispatch, getState) => {
    try {
        const { token } = getState().auth;
        const response = await axios.post(API_URL + '/api/files/delete_survey_file', { id: fileId }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        //console.log("delete response.data", response.data)
        return response.data;
    } catch (error) {
        console.error('Error deleting survey file:', error);
        throw error;
    }
};
